/** Convert ISO date string to input[type=date] value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string =>
  v ? v.substring(0, 10) : '';

/** Convert input[type=date] value to ISO date string */
export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;
